import { CaseDocumentModel } from "./../../models/case-document";
import { GenericDownloadView } from "./generic-download";
import Marionette from "../../../shared/marionette-mustache";
import {autoinject, transient, Container} from "aurelia-dependency-injection";
import {AuthorizationModel} from "../../../authentication/models/authorization-model";
import {AppSettings} from "../../../app-settings";
import {AppEvents} from "../../../app-events";
import { AuthService } from "../../../authentication/auth-service";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

type DownloadOption = "overview" | "cited-cases" | "citing-cases" | "pdf" | "report";

@autoinject
@transient()
export class CaseDownloadView extends GenericDownloadView {

    public template: string;
    public model: CaseDocumentModel;

    constructor(options?: any) {
        super(options);
        this.authService = ContainerHelper.AuthService;
    }

    public onRender() {
        this.setupNonClosingDropDown();
        this.setOptionStatus("overview");
        this.setOptionStatus("cited-cases");
        this.setOptionStatus("citing-cases");
        this.setOptionStatus("pdf");
        this.setOptionStatus("report");
        this.setSubmitButtonStatus();
    }

    protected setOptionStatus(option: DownloadOption) {
        const m: CaseDocumentModel = this.model;
        const $el = this.$(`input[data-download-option^='${option}']`);
        _.each($el, (downloadItem) => {
            let enableOption = false;
            let tooltipMessage;
            const accessSku = m.DocumentAccessSku.toLowerCase();

            switch (option) {
                case "overview":
                    enableOption = accessSku === "pro";
                    tooltipMessage = enableOption ? "" : "You do not have a subscription to this";
                    break;
                case "cited-cases":
                    enableOption = (m.Considered.size() > 0);
                    tooltipMessage = accessSku === "pro" ? "" : "You do not have a subscription to this";
                    break;
                case "citing-cases":
                    enableOption = (m.Subsequent.size() > 0);
                    tooltipMessage = accessSku === "pro" ? "" : "You do not have a subscription to this";
                    break;
                case "pdf":
                    enableOption = (m.HasFullText || m.HasPdf) && (accessSku === "pro");
                    $(downloadItem).prop("checked", enableOption);
                    tooltipMessage = enableOption || accessSku === "pro" ? "" : "You do not have a subscription to this";
                    break;
                case "report":
                    const source: string = $(downloadItem).attr("data-source");
                    enableOption = _.contains(this.authService.AppUser.Indicators, source);
                    tooltipMessage = enableOption ? "" : "You do not have a subscription to this";
                    break;
                default:
                    enableOption = false;
            }
            $(downloadItem).attr(enableOption ? "enabled" : "disabled", true.toString());
            $(downloadItem).prop("title", tooltipMessage);
        });
    }

    protected getQuerystringParams(docKey: string) {
        const selectedOptions: string[] = [];
        this.$(".js-download-option-box:checked").each((idx, item) => {
            selectedOptions.push($(item).attr("data-download-option"));
        });

        let qryString = "";
        let separator = "?";

        $.each(selectedOptions, (index, value) => {
            separator = (index === 0) ? "?" : "&";
            const matches = value.match(/report_(.+)/i);
            if (matches) { // if report
                qryString += separator + "report=" + matches[1].toLowerCase();
            }
            else {
                qryString += separator + value.replace("-", "") + "=true";
            }
        });
        separator = (qryString === "") ? "?" : "&";
        qryString += separator + "docKey=" + docKey;

        return qryString;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/case-download.ts